import React, { useMemo, useState } from "react";
import { Input, Tag } from "@pankod/refine-antd";

type FeatureFlagTagInputProps = {
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
};

export const normalizeFeatureFlagTags = (items: string[]): string[] => {
  return items.map((item) => item.trim()).filter(Boolean);
};

export const FeatureFlagTagInput: React.FC<FeatureFlagTagInputProps> = ({
  value,
  onChange,
  placeholder,
  disabled,
}) => {
  const [draft, setDraft] = useState("");
  const tags = useMemo(() => normalizeFeatureFlagTags(value ?? []), [value]);

  const emitChange = (nextTags: string[]) => {
    onChange?.(normalizeFeatureFlagTags(nextTags));
  };

  const closeDraft = (rawValue = draft) => {
    const nextItems = normalizeFeatureFlagTags(rawValue.split(","));

    if (nextItems.length === 0) {
      setDraft("");
      return;
    }

    emitChange([...tags, ...nextItems]);
    setDraft("");
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;

    if (nextValue.includes(",")) {
      closeDraft(nextValue);
      return;
    }

    setDraft(nextValue);
  };

  const handlePressEnter = () => {
    closeDraft();
  };

  const handleBlur = () => {
    closeDraft();
  };

  const removeTag = (tagToRemove: string, indexToRemove: number) => {
    emitChange(tags.filter((tag, index) => tag !== tagToRemove || index !== indexToRemove));
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "center",
        width: "100%",
      }}
    >
      {tags.map((tag, index) => (
        <Tag
          key={`${tag}-${index}`}
          closable={!disabled}
          onClose={() => removeTag(tag, index)}
        >
          {tag}
        </Tag>
      ))}
      <Input
        aria-label={placeholder}
        disabled={disabled}
        value={draft}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        onPressEnter={handlePressEnter}
        style={{
          flex: "1 1 180px",
          minWidth: 180,
        }}
      />
    </div>
  );
};
